import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import useAuthStore from './hooks/useAuth';

// Auth
import LoginPage from './components/LoginPage';

// Admin
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import AdminCustomers from './admin/AdminCustomers';
import AdminCustomerDetail from './admin/AdminCustomerDetail';
import AdminLogs from './admin/AdminLogs';
import AdminLoginAudit from './admin/AdminLoginAudit';

// Portal (Kundenansicht)
import PortalLayout from './portal/PortalLayout';
import PortalDashboard from './portal/PortalDashboard';
import PortalMails from './portal/PortalMails';
import PortalReports from './portal/PortalReports';
import PortalSettings from './portal/PortalSettings';
import PortalSent from './portal/PortalSent';

function RequireAuth({ children, role }) {
  const { user, isAuthenticated, isLoading } = useAuthStore();
  if (isLoading) return <div className="flex items-center justify-center h-screen">Laden...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (role && user?.role !== role && user?.role !== 'superadmin') {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default function App() {
  const { loadUser } = useAuthStore();
  useEffect(() => { loadUser(); }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        {/* Admin-Bereich */}
        <Route path="/admin" element={
          <RequireAuth role="superadmin">
            <AdminLayout />
          </RequireAuth>
        }>
          <Route index element={<AdminDashboard />} />
          <Route path="kunden" element={<AdminCustomers />} />
          <Route path="kunden/:id" element={<AdminCustomerDetail />} />
          <Route path="logs" element={<AdminLogs />} />
          <Route path="anmeldeprotokoll" element={<AdminLoginAudit />} />
        </Route>

        {/* Kundenportal */}
        <Route path="/portal" element={
          <RequireAuth>
            <PortalLayout />
          </RequireAuth>
        }>
          <Route index element={<PortalDashboard />} />
          <Route path="mails" element={<PortalMails key="mails" />} />
          <Route path="spam" element={<PortalMails key="spam" />} />
          <Route path="gesendet" element={<PortalSent />} />
          <Route path="berichte" element={<PortalReports />} />
          <Route path="einstellungen" element={<PortalSettings />} />
        </Route>

        {/* Root-Redirect */}
        <Route path="/" element={<RootRedirect />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function RootRedirect() {
  const { user, isAuthenticated, isLoading } = useAuthStore();
  if (isLoading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user?.role === 'superadmin') return <Navigate to="/admin" replace />;
  return <Navigate to="/portal" replace />;
}
